import React from 'react';
import {useTranslation} from 'react-i18next';
import store from "@formApp/store";

export default () => {
  const {t, i18n} = useTranslation();
  const {formValues} = React.useContext(store);
  return (
    <>
      <header className="form-heading">
        <h2>{t('Ti abbiamo inviato un\'email')}</h2>
      </header>
      <div className="feedback ok">
        <p>
          <span className="altervista-icon icon-mail"></span>
          {t('Ti abbiamo inviato un\'email all\'indirizzo')} <strong>{formValues.getValue('Email')}</strong>.
          <br />
          {t('Riceverai le istruzioni per proseguire la registrazione via email.')}
        </p>
      </div>
      <p>
        <span dangerouslySetInnerHTML={{__html: t('<strong>Attenzione!</strong> Se non ricevi la mail di conferma entro <strong>48 ore</strong> ripeti l\'iscrizione usando gli stessi dati.')}}></span>
        <br />
        <span dangerouslySetInnerHTML={{__html: t('Controlla anche la cartella di <strong>posta indesiderata</strong>.')}}></span>
        <br />
        <a target="_blank" href={`/feedback.php?who=feedback&amp;lang=${i18n.language}`}>{t('Scrivi qui')}</a> {t('per eventuali problemi')}.
      </p>
      <p className="text-center"><a className="button" href="/">{t('Torna alla pagina principale')}</a></p>
    </>
  )
}